import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: `${API_URL}/api/tableau`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('finance_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const tableauApi = {
  get: () => api.get('/'),
  save: (scene) => api.put('/', { scene }),
};

export default tableauApi;
